const defaultRender = (value) => (value ? value : "--");

const columns = [
  // {
  //   title: "Client",
  //   dataIndex: "name",
  //   render: defaultRender,
  // },
  {
    title: "Start Date",
    dataIndex: "start_date",
    render: defaultRender,
  },
  {
    title: "End Date",
    dataIndex: "end_date",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Document",
    dataIndex: "doc",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;
